import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("App Error:", error, errorInfo);
  }

  handleReload = () => {
    // Unregister SW and clear caches before reload
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((reg) => reg.unregister());
      });
    }
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#FDFBF7",
            fontFamily: "Manrope, sans-serif",
            padding: "20px",
          }}
          data-testid="error-boundary"
        >
          <div style={{ textAlign: "center", maxWidth: "400px" }}>
            <div
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                background: "#FEF2F2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 24px",
                fontSize: "36px",
              }}
            >
              !
            </div>
            <h1
              style={{
                fontSize: "24px",
                fontWeight: "800",
                color: "#042F2E",
                marginBottom: "12px",
              }}
            >
              Algo deu errado
            </h1>
            <p
              style={{
                fontSize: "16px",
                color: "#115E59",
                marginBottom: "32px",
                lineHeight: "1.5",
              }}
            >
              O aplicativo encontrou um erro. Clique abaixo para recarregar.
            </p>
            <button
              onClick={this.handleReload}
              data-testid="reload-button"
              style={{
                background: "#FF5A26",
                color: "#fff",
                border: "none",
                borderRadius: "999px",
                padding: "14px 40px",
                fontSize: "16px",
                fontWeight: "700",
                cursor: "pointer",
              }}
            >
              Recarregar App
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
